import { render, staticRenderFns } from "./LoadingLayout.vue?vue&type=template&id=706b0c6f"
import script from "./LoadingLayout.vue?vue&type=script&lang=js"
export * from "./LoadingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports